/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { CliproConfigUpdate } from '../../models/clipro-config-update';

export interface UpdateCliproConfiguration$Params {

/**
 * The object ID. Must be a valid ID.
 */
  uid: string;

/**
 * The Badgeur Uid.
 */
  badgeurUid: string;

/**
 * The uid of the selected clipro configuration
 */
  cliproUid: string;
  
    /**
     * The CLIPRO configuration update object
     */
    body: CliproConfigUpdate
}

export function updateCliproConfiguration(http: HttpClient, rootUrl: string, params: UpdateCliproConfiguration$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateCliproConfiguration.PATH, 'put');
  if (params) {
    rb.path('uid', params.uid, {});
    rb.path('badgeurUid', params.badgeurUid, {});
    rb.path('cliproUid', params.cliproUid, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateCliproConfiguration.PATH = '/custom/stations/{uid}/badgeur/{badgeurUid}/clipro/{cliproUid}';
